module.exports = __webpack_public_path__ + "static/media/line-brush.5fca8861.png";